import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import CardWithIconTextDescriptionModuleTwo from "@modules/CardWithIconTextDescriptionModuleTwo"
import HandShakeIcon from "@images/about/handshake_with_metaloop.svg"
import CertificationIcon from "@images/about/certification.svg"
import GrowthIcon from "@images/about/growth.svg"

const RaisingTheBarModule = () => {
  const { t } = useTranslation()

  const params = {
    title: t("AboutMetaloop_Section5"),
    firstIcon: HandShakeIcon,
    firstIconTitle: t("AboutMetaloop_Section5_Header1"),
    firstIconDescription: t("AboutMetaloop_Paragraph13"),
    secondIcon: CertificationIcon,
    secondIconTitle: t("AboutMetaloop_Section5_Header2"),
    secondIconDescription: t("AboutMetaloop_Paragraph14"),
    thirdIcon: GrowthIcon,
    thirdIconTitle: t("AboutMetaloop_Section5_Header3"),
    thirdIconDescription: t("AboutMetaloop_Paragraph15"),
  }

  return <CardWithIconTextDescriptionModuleTwo {...params} />
}

export default RaisingTheBarModule
